const devURL = 'http://localhost:8080/';
const httpsURL = 'https://test.yourmorals.net/';

export { devURL, httpsURL };
